import { User } from '@pages/first-time-onboarding/models/user.interface';
import { OnboardingOption } from '@pages/first-time-onboarding/models/onboarding-option.enum';

const actionScope = '[Invite User]';

export class SelectOnboardingOption {
  static readonly type = `${actionScope} Select Onboarding Option`;
  constructor(public onboardingOption: OnboardingOption) {}
}

export class CheckUserExistence {
  static readonly type = `${actionScope} Check User Existence`;
  constructor(public userEmail: string) {}
}

export class InviteUser {
  static readonly type = `${actionScope} Invite User`;
  constructor(public user: User) {}
}

export class InviteUserCompleted {
  static readonly type = `${actionScope} Invite User Completed`;
}
